import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deployed: false,
  area: undefined,
  foreman: null,
  responsibleBusiness: null,
  salesman: null,
  managementAssistant: null,
  supplier: null,
  plan: undefined,
  UEControl: undefined,
  maintenanceContract: undefined,
  safetyStudy: undefined,
  CEControl: undefined,
  internalControl: undefined,
  status: undefined,
  deviceStatus: undefined,
  workType: undefined,
  valueBigFilter: "",
  selectBigFilter: undefined,
  page: 1,
  userArea: undefined,
  userRole: undefined,
  userSuperior: null,
  userValueBigFilter: "",
  userSelectBigFilter: undefined,
  modelValueBigFilter: "",
  modelSelectBigFilter: undefined,
  modelSupplier: null,
  supplierValueBigFilter: "",
  supplierSelectBigFilter: undefined,
  supplierDeviceType: null,
  planningRows: [],
  sortBy: "last_modified",
  myOrders: true,
};

export const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setDeployed: (state, action) => {
      state.deployed = action.payload;
    },
    setArea: (state, action) => {
      state.area = action.payload;
    },
    setForeman: (state, action) => {
      state.foreman = action.payload;
    },
    setResponsibleBusiness: (state, action) => {
      state.responsibleBusiness = action.payload;
    },
    setSalesman: (state, action) => {
      state.salesman = action.payload;
    },
    setManagementAssistant: (state, action) => {
      state.managementAssistant = action.payload;
    },
    setSupplier: (state, action) => {
      state.supplier = action.payload;
    },
    setPlan: (state, action) => {
      state.plan = action.payload;
    },
    setMaintenanceContract: (state, action) => {
      state.maintenanceContract = action.payload;
    },
    setSafetyStudy: (state, action) => {
      state.safetyStudy = action.payload;
    },
    setCEControl: (state, action) => {
      state.CEControl = action.payload;
    },
    setUEDeclaration: (state, action) => {
      state.UEDeclaration = action.payload;
    },
    setInternalControl: (state, action) => {
      state.internalControl = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setDeviceStatus: (state, action) => {
      state.deviceStatus = action.payload;
    },
    setWorkType: (state, action) => {
      state.workType = action.payload;
    },
    setValueBigFilter: (state, action) => {
      state.valueBigFilter = action.payload;
    },
    setSelectBigFilter: (state, action) => {
      state.selectBigFilter = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setUserValueBigFilter: (state, action) => {
      state.userValueBigFilter = action.payload;
    },
    setUserSelectBigFilter: (state, action) => {
      state.userSelectBigFilter = action.payload;
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    setUserArea: (state, action) => {
      state.userArea = action.payload;
    },
    setUserSuperior: (state, action) => {
      state.userSuperior = action.payload;
    },
    setModelValueBigFilter: (state, action) => {
      state.modelValueBigFilter = action.payload;
    },
    setModelSelectBigFilter: (state, action) => {
      state.modelSelectBigFilter = action.payload;
    },
    setModelSupplier: (state, action) => {
      state.modelSupplier = action.payload;
    },
    setSupplierValueBigFilter: (state, action) => {
      state.supplierValueBigFilter = action.payload;
    },
    setSupplierSelectBigFilter: (state, action) => {
      state.supplierSelectBigFilter = action.payload;
    },
    setSupplierDeviceType: (state, action) => {
      state.supplierDeviceType = action.payload;
    },
    setPlanningRows: (state, action) => {
      state.planningRows = action.payload;
    },
    setSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
    setMyOrders: (state, action) => {
      state.myOrders = action.payload;
    },
  },
});

export const {
  deployed,
  setDeployed,
  setArea,
  setForeman,
  setResponsibleBusiness,
  setSalesman,
  setManagementAssistant,
  setSupplier,
  setPlan,
  setMaintenanceContract,
  setSafetyStudy,
  setCEControl,
  setUEDeclaration,
  setInternalControl,
  setStatus,
  setDeviceStatus,
  setWorkType,
  setValueBigFilter,
  setSelectBigFilter,
  setPage,
  setUserValueBigFilter,
  setUserSelectBigFilter,
  setUserRole,
  setUserArea,
  setUserSuperior,
  setModelValueBigFilter,
  setModelSelectBigFilter,
  setModelSupplier,
  setSupplierValueBigFilter,
  setSupplierSelectBigFilter,
  setSupplierDeviceType,
  planningRows,
  setPlanningRows,
  setSortBy,
  setMyOrders,
} = filtersSlice.actions;

export default filtersSlice.reducer;
